import { render } from "./DockerImageInspect.vue?vue&type=template&id=bcedb950"
import script from "./DockerImageInspect.vue?vue&type=script&lang=js"
export * from "./DockerImageInspect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__